<div class="custom-modal modal-container" id="wrapper">
    <div class="modal-header">
        <h6 class="modal-title text-center">Roles and Permissions</h6>
    </div>
    <div class="modal-body">
        <div class="container">
            <div class="container">
                   
                <div class="no-per-div">
                    <img alt="no-permission" src="assets/images/no-permission.png" /> 
                    <p>Access Restricted.</p>
                    <p>Please contact your administrator.</p>
                </div>
            </div>
            
        </div>
    </div>
    <div class="modal-footer">
        <div  class="confirm-actions">
            
            <button class="btn action-btn submit" (click)="confAction()">Ok<span class="submit-btn"></span></button>
        </div>
        
        
    </div>
</div>

